import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OutgoingCallStatuses, ParticipantState } from '../types';
import { IncomingPostMessage, SetMuteOutgoingPayload, SyncMediaDevicePayload } from './types';

interface OutgoingCall {
    status: OutgoingCallStatuses;
    callee: Maybe<ParticipantState>;
}

type MessengerState = {
    outgoingCall: OutgoingCall;
    backButtonVisible: boolean;
};

const initialState: MessengerState = {
    outgoingCall: {
        status: OutgoingCallStatuses.RINGING,
        callee: undefined,
    },
    backButtonVisible: false,
};

const messengerSlice = createSlice({
    name: 'messenger',
    initialState,
    reducers: {
        setOutgoingCallStatus(state, action: PayloadAction<OutgoingCallStatuses>) {
            state.outgoingCall.status = action.payload;
        },
        setOutgoingCallCallee(state, action: PayloadAction<Maybe<ParticipantState>>) {
            state.outgoingCall.callee = action.payload;
        },
        setBackButtonVisible(state, action: PayloadAction<boolean>) {
            state.backButtonVisible = action.payload;
        },
        resetMessengerState() {
            return initialState;
        },
    },
});
export const syncMediaDeviceAction = createAction<SyncMediaDevicePayload>('conference/messenger/syncMediaDeviceAction');
export const acceptCallAction = createAction('conference/messenger/acceptCallAction');
export const screenRecordingAction = createAction<IncomingPostMessage>('conference/messenger/screenRecordingAction');
export const sendAudioInputDeviceStatusAction = createAction<SetMuteOutgoingPayload>(
    'conference/messenger/sendAudioInputDeviceStatusAction'
);
export const sendVideoInputDeviceStatusAction = createAction<SetMuteOutgoingPayload>(
    'conference/messenger/sendVideoInputDeviceStatusAction'
);
export const { setOutgoingCallStatus, setOutgoingCallCallee, setBackButtonVisible, resetMessengerState } =
    messengerSlice.actions;

export const messengerReducer = messengerSlice.reducer;
